module.exports = __webpack_public_path__ + "img/Zain_B2B_Classera.7c840e53.png";